import {call, put} from 'redux-saga/effects';
import {clientQuery} from 'Core/data/GraphQLApi';
import {endpoints} from 'Core/defaultValues';
import {ExceptionManager} from 'Core/logManager';
// Actions
import {reportsMainGenerateReportProgress, reportsMainGenerateReportUpdate} from 'Redux/actions';

import {
    baseReportConditions,
    generateReportInstance,
    getTimeZone,
    handleAsyncReport,
    isJsonFormat
} from 'Modules/reports/views/main/components/reportsTab/helper';
import {getAbbvTimezone} from "Components/uiControls/Timezone/tools";

function* getDriverFormsReportV2(report, page, rowsPerPage, sortField, sortOrder, requestFlag) {
    const {timeZone, sendByEmail, emailsTo, name, timeframeName, categoryName, delayed, dataResultPath} = report;
    const {filterType, filterArray, startRange, endRange, unitsSelected, accumulateData = true, dates, otherFilters} = report.filters

    const baseConditionsQuery = baseReportConditions({
        report,
        name,
        dataResultPath,
        timeZone,
        delayed,
        unitsSelected,
        timeframeName,
        filterType,
        filterArray,
        categoryName,
        startRange,
        endRange,
        dates
    })
    try {
        const filtersForms = otherFilters?.form === 1 ? [] : {
            values: otherFilters?.form
        }
        let payload = {
            conditions: {
                ...baseConditionsQuery,
                stringValues: filtersForms,
                sortField: {
                    field: sortField || "deviceId",
                    order: sortOrder === 'desc' ? 'DESC' : 'ASC'
                }
            },
            limit: rowsPerPage,
            offset: page
        };

        let columns = [
            {
                "column": "idLabel",
                "header": "Driver"
            },
            {
                "column": "unitTime",
                header: `${report?.exportType === "csv" ? `Time & Date (${getAbbvTimezone(timeZone)})` : `Time & Date`}`
            },
            {
                "column": "address",
                "header": "Address"
            },
            {
                "column": "formName",
                "header": "Form"
            },
            {
                "column": "label",
                "header": "Question"
            },
            {
                "column": "value",
                "header": "Answer"
            }
        ]

        payload = {
            ...payload,
            limit: isJsonFormat(report?.exportType, dataResultPath) ? rowsPerPage : 5000,
            offset: isJsonFormat(report?.exportType, dataResultPath) ? page : 1,
            conditions: {
                ...payload.conditions,
                exportOptions: {
                    sendByEmail,
                    emailsTo,
                    format: {
                        fileFormat: report?.exportType || "json",
                        formatOptions: "{\"addPagination\": \"true\", \"addLogo\": \"true\", \"addLine\": \"true\", \"rowPageBreak\": \"avoid\"}",
                        durationFormat: report?.durationFormat
                    },
                    culture: report.lang,
                    timeZone: getTimeZone(timeZone),
                    folderName: "px-customer-reports",
                    filePrefixName: "DriverFormsReport",
                    columns
                }
            }
        }
        let data = yield call(
            clientQuery,
            `query getDriverFormsReportV2 ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
                Report: getDriverFormsReportV2 (conditions: $conditions, limit: $limit, offset: $offset) {
                    ${generateReportInstance(report.export, dataResultPath, report.exportFromTable) ?
                `reportInstanceId`
                : `
                    items {
                        recordInfo {
                            entityId
                            entityLabel
                            tagId
                            tagLabel
                            startDate
                            endDate
                            recordType
                            groupLabel
                            groupIndex
                            groupTotal
                            groupTagColor
                        }
                        recordDetail {
                            id
                            driverId
                            driverName
                            unitTime
                            formName
                            address
                            formValues {
                                label
                                value
                                type
                            }
                            noData
                        }
                    }
                    total
                    limit
                    offset
                    category
                  `}
                }
              }`,
            payload,
            endpoints.GRAPHQL_PX_REPORTING,
        );
    yield handleAsyncReport(report, data, accumulateData);
    } catch (exc) {
        ExceptionManager(exc, 'reports/driverFormsReportV2', 'getDriverFormsReportV2');
        report.loading = false
        yield put(reportsMainGenerateReportProgress(report))
        if (!requestFlag) {
            let flag = true
            yield put(reportsMainGenerateReportUpdate(report, page, rowsPerPage, sortField, sortOrder, flag))
        } else {
            report.loading = false
            yield put(reportsMainGenerateReportProgress(report))
        }
    }
}


export default getDriverFormsReportV2;
